export { default as customerReducer } from './customer.reducer';
export { default as watchCustomer } from './customer.saga';
export * from './customer.types';
export * from './customer.actions';